import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "logout-prompt"
  }, [_c('div', {
    staticClass: "logout-prompt-content"
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.t('注销须知')))]), _c('div', [_vm._v(_vm._s(_vm.t('如您决定注销在谷仓信息系统（{0}，下称“信息系统”）注册的客户代码/账号（下称“客户代码”或“账号”），则请您仔细阅读本须知内容，并确认无误后进行下一步操作。如您不认同或未能完全清晰理解本须知内容的，则您不应继续操作注销流程并应即可退出本界面。', [_vm.gdUrl])))]), _c('ol', {
    staticClass: "mt-10"
  }, [_c('li', [_vm._v(_vm._s(_vm.t('客户代码一旦启动注销程序则不可恢复，您将无法再继续登录、使用客户代码。')))]), _c('li', [_c('span', [_vm._v(_vm._s(_vm.t('客户代码启动注销流程时将开始清理删除客户代码下的相关数据及信息，包括但不限于:用户名、货物信息、用户认证信息等，但已完成服务的运单信息将按照')))]), _c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "target": "_blank",
      "data-permission": "customer_logout_account_privacy_terms_file",
      "id": "customer_logout_account_privacy_terms_file",
      "href": _vm.commonBizList.privacy_terms_file,
      "fbu-analyse-name": $t("\u9690\u79C1\u653F\u7B56")
    }
  }, [_vm._v(_vm._s(_vm.t('隐私政策')))]), _c('span', [_vm._v(_vm._s(_vm.t('记载的时限保存。')))])]), _c('li', [_vm._v(_vm._s(_vm.t('请您重点关注：如您决定注销客户代码，则您需要确保在注销前妥善处理未结事宜，包括付清未结清的款项、申请退回账号余额、安排库内货物转移或清理等，否则可能会给您的工作造成不便。')))]), _c('li', [_vm._v(_vm._s(_vm.t('您承诺，如您指派您的员工或代理人注销客户代码，则该员工或代理人的行为由您负责。')))]), _c('li', [_vm._v(_vm._s(_vm.t('您注销客户代码的行为并不影响客户代码注销前已成就的行为，也不减轻或豁免您应当承担的责任与义务。')))])])]), _c('div', {
    staticClass: "logout-prompt-btn",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a-button', {
    staticClass: "mr-20",
    staticStyle: {
      "min-width": "74px"
    },
    attrs: {
      "data-permission": "customer_logout_account_back",
      "id": "customer_logout_account_back",
      "fbu-analyse-name": $t("\u8FD4\u56DE")
    },
    on: {
      "click": _vm.handleBack
    }
  }, [_vm._v(_vm._s(_vm.t('返回')))]), _c('a-button', {
    attrs: {
      "type": "primary",
      "data-permission": "customer_logout_account_next",
      "id": "customer_logout_account_next",
      "fbu-analyse-name": $t("\u4E0B\u4E00\u6B65")
    },
    on: {
      "click": _vm.handleNext
    }
  }, [_vm._v(_vm._s(_vm.t('下一步')))])], 1)]);
};

var staticRenderFns = [];
export { render, staticRenderFns };